import { ActionTypes } from "@/App/constants/actionTypes";
import { TransmissionTypes } from "@/types";

type SubmitTransmissionTestAsBatchAction = {
  type: typeof ActionTypes.SUBMIT_TRANSMISSION_TEST_AS_BATCH;
  payload: TransmissionTypes.TransmissionData;
  formName: string;
};

export const submitTransmissionTestAsBatch = (
  payload: TransmissionTypes.TransmissionData,
  formName: string,
): SubmitTransmissionTestAsBatchAction => {
  return {
    type: ActionTypes.SUBMIT_TRANSMISSION_TEST_AS_BATCH,
    payload,
    formName,
  };
};

export type TransmissionTestAsBatchActions = SubmitTransmissionTestAsBatchAction;
